import { defineRoute } from '@kestrel/router';

/*                                            */
export const routes = [
    defineRoute({
        path: '/tilelist',
        component: () => import('./routes/tilelist/page.svelte'),
        server: () => import('./routes/tilelist/page.server.ts'),
    }),
    defineRoute({
        path: '/tilelist-lite',
        component: () => import('./routes/tilelist-lite/page.svelte'),
        server: () => import('./routes/tilelist-lite/page.server.ts'),
    }),
    defineRoute({
        path: '/tilelist-fallback',
        component: () => import('./routes/tilelist-fallback/page.svelte'),
        server: () => import('./routes/tilelist-fallback/page.server.ts'),
    }),
    defineRoute({
        path: '/internal/health',
        methods: () => import('./routes/health/Health.server.ts'),
    }),
];
